app.controller("StudentPaymentScheduleController", [
    "$scope", "Students", "SysParam", "$uibModal", "AuthService", "StaticData", "$q", "Payments", "$state", "toastr", "$window",
    function ($scope, Students, SysParam, $uibModal, AuthService, StaticData, $q, Payments, $state, toastr, $window) {
        $scope.currentDebit = '-';
        $scope.selectedSchedule = null;
        $scope.scheduleInfo = [];
        $scope.acceptTerms = false;
        $scope.acceptChoice = false;
        $scope.months = {};
        var profile = null;
        AuthService.getUserData().then(function (user) {
            profile = AuthService.pickStudentProfile(user);
            SysParam.getSysParam("financialSeason").then(function (param) {
                $scope.financialSeason = param.value;
                if (profile.info.scheduleSelected === $scope.financialSeason) {
                    $state.go('student-new.index');
                } else {
                    Payments.scheduleList().then(function (data) {

                        if (data && data[0].archevani === 0) {
                            $scope.schedules = [];
                            AuthService.getPass().then(() => {
                                $state.go('student-new.index');
                            });


                        } else if (data && data.length) {
                            AuthService.getPass();
                            $scope.schedules = data;
                            $scope.currentDebit = data[0].tax;
                        }
                    });
                }
            });
        });

        SysParam.getSysParam("financialSeason").then(function (param) {
            var season = param.value.slice(5)
            StaticData.getItemsByKey("months").then(function (data) {
                $scope.months = data[0][season];
            });
        })

        function formatScheduleInfo(schedule) {
            $scope.scheduleInfo = Object.keys($scope.months).map(function (month) {
                if (schedule.hasOwnProperty(month) && schedule[month] > 0) {
                    var day = (schedule[month + '_day'] || '').substring(8, 10)
                    day = day ? parseInt(day) : '';
                    return { month: months[month], amount: schedule[month], day: day };
                }
                return null;
            }).filter(function (el) { return el; });
        }

        $scope.selectSchedule = function (schedule, $event) {
            $event.stopPropagation();
            if (schedule && schedule.validuroba === 0) {
                toastr.warning("მოცემული გრაფიკის არჩევა ამჟამად შეუძლებელია, არჩევის ვადა ამოწურულია");
                return;
            }
            $scope.selectedSchedule = schedule;
            if (schedule) {
                formatScheduleInfo(schedule);
            }
        }

        $scope.submit = function () {
            Payments.updateSchedule({ model_id: $scope.selectedSchedule.model_id }).then(function () {
                toastr.success("არჩევანი დაფიქსირებულია. გმადლობთ");
                if (profile) {
                    profile.info.scheduleSelected = $scope.financialSeason;
                }
                $state.go('student-new.index');
            }).catch(function () {
                toastr.error('', 'დაფიქსირდა შეცდომა');
            });
        }

    }
]);
